export default __webpack_public_path__ + "static/media/IMG_9981.4f6e4868.jpg";